import { getAuthHeaders, getBaseUrl } from './apiClient';

export type WordpressBlogCategory = {
  name: string;
  slug: string;
  wp_id: number;
};

export const blogWordpressCategoriesService = {
  async list(): Promise<{ categories: WordpressBlogCategory[]; count: number }> {
    const resp = await fetch(`${getBaseUrl()}/secure/blog/wordpress-categories`, {
      headers: await getAuthHeaders()
    });
    if (!resp.ok) {
      const text = await resp.text();
      throw new Error(`Failed to list WordPress categories (${resp.status}) ${text}`);
    }
    return await resp.json();
  }
};
